import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

interface ConfigResponse {
  data: {
    place: {
      id: number;
      name: string;
      logo:  string;
      is_mutable: boolean;
      login_required: boolean;
    },
    config: {
      primary_color: string;
      background_image: string;
      view_type: number;
      tyc_url: string;
      tc_raw: string
      login: boolean;
    },
  }
}

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getConfiguration(gsid: number): Observable<ConfigResponse> {
    const headers = new HttpHeaders({
      'cli': 'Web',
      'appversion': '1.5',
      'serviceversion': '2',
      'latitude': '0',
      'longitude': '0',
      'placeType': 'company',
      'placeId': gsid,
      'infoLevel': '2',
      'Authorization': `Bearer ${localStorage.getItem('gstoken') || ''}`
    });

    return this.http.get<ConfigResponse>(`${this.baseUrl}/places/config`, { headers });
  }




}